import { PropsWithChildren } from "react";
import { useLocation } from "react-router-dom";
import { isMarketplacePath } from "@/utils/marketplaceNavigation";

export const MainLayoutContent = ({ children }: PropsWithChildren) => {
  const { pathname } = useLocation();
  return (
    <div className={isMarketplacePath(pathname) ? "py-6 lg:py-8" : "lg:py-8"}>
      {children}
    </div>
  );
};
